import { render, staticRenderFns } from "./CButtonBorder.vue?vue&type=template&id=3160bc46&scoped=true"
import script from "./CButtonBorder.vue?vue&type=script&lang=js"
export * from "./CButtonBorder.vue?vue&type=script&lang=js"
import style0 from "./CButtonBorder.vue?vue&type=style&index=0&id=3160bc46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160bc46",
  null
  
)

export default component.exports